import { render, staticRenderFns } from "./ProgrammaExtraEsterno.vue?vue&type=template&id=57cb5cc3&scoped=true&"
import script from "./ProgrammaExtraEsterno.vue?vue&type=script&lang=js&"
export * from "./ProgrammaExtraEsterno.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammaExtraEsterno.vue?vue&type=style&index=0&id=57cb5cc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cb5cc3",
  null
  
)

export default component.exports